module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./GoogleLoginTipView.js"));
	}, "GoogleLoginTipView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GoogleLoginTipView!./src/pages/Login/GoogleLoginTip/GoogleLoginTipView.js
// module id = 1339
// module chunks = 418